import { atom, useRecoilValue, useRecoilTransaction_UNSTABLE } from "recoil";

import { QueryStatus } from "../../../services/query";
import activities from "../../../redux/activities";
import { SimpleSetValue } from "../../../types";

/////////
// START: Block to be removed once deprecated crops hook is removed.
/////////

// Do NOT export atoms.
// This allows us to limit usage of these to only the hooks we export below.

const cropsGlobalActivityAtom = atom<activities>({
  key: "[@fabric/core] cropsGlobalActivityAtom",
  default: activities.idling,
});

const cropsGlobalStatusAtom = atom<QueryStatus>({
  key: "[@fabric/core] cropsGlobalStatusAtom",
  default: "idle",
});

// ############################
// ## useCropsGlobalActivity ##
// ############################

export type ResultOfUseCropsGlobalActivity = activities;
export type UseCropsGlobalActivity = () => ResultOfUseCropsGlobalActivity;

/**
 * @returns The last crops activity from `useCrops`.
 *
 * @deprecated Use `useCrops` instead. This is only necessary to support deprecated hooks.
 */
export const useCropsGlobalActivity: UseCropsGlobalActivity = () => {
  return useRecoilValue(cropsGlobalActivityAtom);
};

// ##########################
// ## useCropsGlobalStatus ##
// ##########################

export type ResultOfUseCropsGlobalStatus = QueryStatus;
export type UseCropsGlobalStatus = () => ResultOfUseCropsGlobalStatus;

/**
 * @returns the last status of the last crops activity from `useCrops`.
 *
 * @deprecated Use `useCrops` instead. This is only necessary to support deprecated hooks.
 */
export const useCropsGlobalStatus: UseCropsGlobalStatus = () => {
  return useRecoilValue(cropsGlobalStatusAtom);
};

// #############################################
// ## useSetCropsGlobalActivityAndStatus ##
// #############################################

export type ResultOfUseSetCropsGlobalActivityAndStatus = SimpleSetValue<{
  activity: activities;
  status: QueryStatus;
}>;
export type UseSetCropsGlobalActivityAndStatus =
  () => ResultOfUseSetCropsGlobalActivityAndStatus;

/**
 * Allows setting the last crops activity and
 * the status of that activity.
 *
 * @deprecated This is only necessary to support deprecated hooks.
 */
export const useSetCropsGlobalActivityAndStatus: UseSetCropsGlobalActivityAndStatus =
  () => {
    // Using useRecoilTransaction_UNSTABLE ensures that the atoms are updated atomically
    return useRecoilTransaction_UNSTABLE(
      ({ set }) =>
        (payload: { activity: activities; status: QueryStatus }) => {
          set(cropsGlobalActivityAtom, payload.activity);
          set(cropsGlobalStatusAtom, payload.status);
        },
      [],
    );
  };

///////
// END: Block to be removed once deprecated crops hook is removed.
///////
